import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class reportService {
  async fetchWorkJourney(params) {
    try {
      const result = await client.get('user/workjourney', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchLastContact(params) {
    try {
      const result = await client.get('report/lastcontact', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchAccess(params) {
    try {
      const result = await client.get('report/authlogreport', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchIntegrationLog(params) {
    try {
      const result = await client.get('report/integrationlog', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchRequestsPerManager(params) {
    try {
      const result = await client.get('report/requestspermanager', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchNotifications(params) {
    try {
      const result = await client.get('notification/index', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new reportService();
